import { timerActions } from "../../../store/timerSlice"
import { UrlConstant } from "../../../urlConstant/UrlConstant"
import { useHttpRequest } from "../../../utils"
import useCallBack, { Callbacks } from "../../../utils/callback/useCallBack"
import { TimerFilter } from "../types"

export const GetAllTimersMutation = <T>(
    filter: TimerFilter,
    callbacks?: Callbacks<T>
) => {
    const { onError, onLoading, onSuccess } = useCallBack<any>(callbacks)

    const { postRequest } = useHttpRequest({})
    return async (dispatch: any) => {
        const getTimers = async () => {
            try {
                const response = await postRequest(`${UrlConstant.Timer}/${UrlConstant.GetByFiltered}`, {
                    ...filter,
                })
                const data = await response
                return data
            }
            catch (error) {
                onError(error as Error)
            }
        }
        try {
            const res = await getTimers()
            if (res) {
                const response = res?.data ?? []
                if (response && Array.isArray(response)) {
                    const hasMore = res.data.hasNext
                    const rowCount = res.data.rowCount
                    dispatch(timerActions.getData({ hasMore, rowCount, data: response }))
                    onSuccess(response);
                } else {
                    dispatch(timerActions.getRecord(response))
                }
            }

        } catch (error) {
            onError(error as Error)
        } finally {
            onLoading(false)
        }
    }
}
